var _defs, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack178({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.5,
    y: 5.53,
    width: 0.97,
    height: 4.95
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 7.52,
    y: -0.52,
    width: 0.97,
    height: 13.06,
    transform: "translate(1.99 14.01) rotate(-90)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 7.52,
    y: 3.46,
    width: 0.97,
    height: 13.06,
    transform: "translate(-1.99 17.99) rotate(-90)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 14.53,
    y: 5.53,
    width: 0.97,
    height: 4.95
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack178);
export default __webpack_public_path__ + "static/media/Symbolpack_1_78.534ba9e2ec71708f1189b8e0f07b925d.svg";
export { ForwardRef as ReactComponent };